'use client'

import { useMemo, type PropsWithChildren } from 'react'

import { SpaceLayoutClient as SharedSpaceLayoutClient } from '@/components/space/space-layout-client'
import type { SceneID } from '@/enums/agent'
import type { ModelConfigItem } from '@/lib/api/models/config'
import { useModelStore } from '@/stores'

interface SpaceLayoutClientProps extends PropsWithChildren {
  defaultOpen?: boolean
}

/** Match FLUX 3 Video from /v1/lyart/models by sceneId or name/shortName */
export function findFlux3Model(modelConfigs: ModelConfigItem[]): ModelConfigItem | undefined {
  return modelConfigs.find(
    m =>
      String(m.sceneId) === '62' || /flux\s*3/i.test(m.name) || /flux\s*3/i.test(m.shortName ?? '')
  )
}

export function findFlux3SceneId(modelConfigs: ModelConfigItem[]): SceneID | undefined {
  return findFlux3Model(modelConfigs)?.sceneId
}

/**
 * FLUX 3 Video page layout client.
 * Uses shared SpaceLayoutClient with basePath /flux3-video；
 * 默认模型从 modelConfigs 按 sceneId/名称解析（接口下发）
 */
export const SpaceLayoutClient = ({ children, defaultOpen = true }: SpaceLayoutClientProps) => {
  const modelConfigs = useModelStore(s => s.modelConfigs)
  const defaultModelId = useMemo(() => findFlux3SceneId(modelConfigs), [modelConfigs])

  return (
    <SharedSpaceLayoutClient
      config={{ basePath: '/flux3-video', defaultModelId }}
      defaultOpen={defaultOpen}
    >
      {children}
    </SharedSpaceLayoutClient>
  )
}
